import {useQueryClient} from '@tanstack/react-query';
import {MetadataQueryKey} from '../../context/MetadataContext';
import {
  DeleteSignalDefinition,
  SaveSignalDefinition,
} from '../../shared/api/definitions/signalDefinition';
import {useApiMutation} from './api';

export const useSaveSignalDefinition = () => {
  const queryClient = useQueryClient();
  return useApiMutation(SaveSignalDefinition, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const useDeleteSignalDefinition = () => {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteSignalDefinition, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};
